import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AppStateService } from '../services/app-state.service';
import { filter, first, map } from 'rxjs/operators';

export const AdminGuard: CanActivateFn = () => {
    const router = inject(Router);
    const appStateService = inject(AppStateService);
    return appStateService.userInfo$.pipe(
        filter((userInfo) => !!userInfo?.user),
        first(),
        map((userInfo) => {
            const isSuperUser = userInfo?.user?.is_superuser;
            const isSiloAdmin = userInfo?.user?.is_silo_admin;
            return isSuperUser || isSiloAdmin ? true : router.parseUrl('/app/profile');
        }),
    );
};
